import { render, staticRenderFns } from "./Reversdialog_helthcheck.vue?vue&type=template&id=1bb67d63&scoped=true&"
import script from "./Reversdialog_helthcheck.vue?vue&type=script&lang=js&"
export * from "./Reversdialog_helthcheck.vue?vue&type=script&lang=js&"
import style0 from "./Reversdialog_helthcheck.vue?vue&type=style&index=0&id=1bb67d63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb67d63",
  null
  
)

export default component.exports